import { Helmet } from "react-helmet-async";
import { useSEO } from "@/hooks/useSEO";

export function SEOHead({ pageSlug, fallback = {}, title: directTitle, description: directDescription }) {
  const seo = useSEO(pageSlug, fallback);

  // Direct props take precedence over SEO settings and fallback
  const title = directTitle || seo.meta_title || fallback.meta_title || "Prime Media Wireless";
  const description = directDescription || seo.meta_description || fallback.meta_description || "";
  const keywords = seo.all_keywords || seo.meta_keywords || fallback.meta_keywords || "";
  const robots = seo.robots || "index, follow";
  const canonical = seo.canonical_url || fallback.canonical_url || "";
  const ogTitle = seo.og_title || title;
  const ogDesc = seo.og_description || description;
  const ogImage = seo.og_image || "";
  const ogType = seo.og_type || "website";
  const ogUrl = seo.og_url || canonical || "";
  const siteName = seo.site_name || "Prime Media Wireless";
  const twitterCard = seo.twitter_card || "summary_large_image";
  const twitterTitle = seo.twitter_title || ogTitle;
  const twitterDesc = seo.twitter_description || ogDesc;
  const twitterImage = seo.twitter_image || ogImage;
  const schemaJson = seo.schema_json || "";

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={robots} />
      {canonical && <link rel="canonical" href={canonical} />}

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={siteName} />
      {ogTitle && <meta property="og:title" content={ogTitle} />}
      {ogDesc && <meta property="og:description" content={ogDesc} />}
      {ogUrl && <meta property="og:url" content={ogUrl} />}
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content={twitterCard} />
      {twitterTitle && <meta name="twitter:title" content={twitterTitle} />}
      {twitterDesc && <meta name="twitter:description" content={twitterDesc} />}
      {twitterImage && <meta name="twitter:image" content={twitterImage} />}

      {schemaJson && (
        <script type="application/ld+json">{schemaJson}</script>
      )}
    </Helmet>
  );
}
